// extracted by mini-css-extract-plugin
export default {"root":"Main_root__dPGNZ"};